import script from "./AddMultipleMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMultipleMembers.vue?vue&type=script&setup=true&lang=js"

import "./AddMultipleMembers.vue?vue&type=style&index=0&id=9e10882e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e10882e"]])

export default __exports__